import { DataProxy } from 'apollo-cache'
import { errorPreventiveCacheRead } from '@sketch/modules-common'
import {
  GetScimPersonalAccessTokensDocument,
  GetScimPersonalAccessTokensQuery,
  GetScimPersonalAccessTokensQueryVariables,
} from '@sketch/gql-types'

type Me = GetScimPersonalAccessTokensQuery['me']

const get = (cache: DataProxy): Me | undefined => {
  return errorPreventiveCacheRead<
    GetScimPersonalAccessTokensQuery,
    GetScimPersonalAccessTokensQueryVariables
  >(cache, { query: GetScimPersonalAccessTokensDocument, variables: {} })?.me
}

const set = (cache: DataProxy, me: Me): void => {
  cache.writeQuery<
    GetScimPersonalAccessTokensQuery,
    GetScimPersonalAccessTokensQueryVariables
  >({
    query: GetScimPersonalAccessTokensDocument,
    data: { __typename: 'RootQueryType', me },
  })
}

export { get, set }
